import { baseUrl, handleResponse, handleError, GetHeaders } from "../common/ApiUtils";

const apiUrl = baseUrl + "Options/Employee";

export function getEmployeeStatement(employeeId) {
    return fetch(`${apiUrl}/${employeeId}/Statement`, GetHeaders()).then(handleResponse).catch(handleError);
}

export function getEmployeeStatementForActivity(employeeId) {
    return fetch(`${apiUrl}/${employeeId}/Statement/Activity`, GetHeaders()).then(handleResponse).catch(handleError);
}
